import * as Yup from "yup";

const validationDefault = {
  quantity_invoice: Yup.number()
    .nullable()
    .transform((value, originalValue) => (originalValue === "" ? null : value))
    .positive("Quantidade deve ser positiva")
    .typeError("Campo deve ser um número"),
  invoice_number: Yup.string()
    .required("Número da nota fiscal é obrigatório")
    .typeError("Campo deve ser uma string"),
  invoice_issue_date: Yup.date()
    .required("Data de emissão da nota fiscal é obrigatória")
    .typeError("Data inválida"),
  observation: Yup.string().typeError("Campo deve ser uma string").max(255)
};

export const validationSchemaCreate = Yup.object().shape(validationDefault);
